export const PRO = (process.env.NODE_ENV ===  'production' || process.env.NODE_ENV === 'pro')

export const API = PRO
	? 'https://hubdigitalzf.owius.com:4006/api'
	: 'http://localhost:4001/api'

export const SERVER_URL = PRO
	? 'https://hubdigitalzf.owius.com:4006'
	: 'http://localhost:4001'
